<div class="container-fluid config-layout-shell px-0" :class="{ 'onboarding-layout-shell': is_onboarding_system_layout }">
  <div
    v-if="show_mobile_drawer && !should_hide_sidebar"
    class="mobile-backdrop"
    @click="close_mobile_sidebar"
  ></div>

  <div v-if="show_mobile_drawer && !should_hide_sidebar" class="mobile-drawer">
    <button
      class="mobile-drawer-close btn p-0 border-0 bg-transparent"
      @click="close_mobile_sidebar"
      aria-label="Close menu"
    >
      <i class="bi bi-x-lg fs-5"></i>
    </button>
    <ConfigSidebar @close="close_mobile_sidebar" />
  </div>

  <div class="row g-0 h-100 position-relative">
    <div
      v-if="show_desktop_sidebar"
      :class="[
        'sidebar-shell d-flex',
        is_sidebar_hidden ? 'sidebar-shell-collapsed' : 'sidebar-shell-expanded'
      ]"
    >
      <div class="sidebar-col">
        <div class="flex-grow-1 h-100">
          <ConfigSidebar @close="is_sidebar_hidden = true" />
        </div>
      </div>

      <button
        v-if="!is_onboarding_system_layout"
        type="button"
        class="sidebar-toggle-arrow d-none d-lg-flex align-items-center justify-content-center position-absolute btn-primary-dark rounded-circle shadow border-0"
        :class="is_sidebar_hidden ? 'arrow-collapsed' : 'arrow-expanded'"
        @click="is_sidebar_hidden = !is_sidebar_hidden"
      >
        <i
          class="bi text-white fs-6"
          :class="is_sidebar_hidden ? 'bi-chevron-right' : 'bi-chevron-left'"
        ></i>
      </button>
    </div>

    <div
      class="main-content-wrapper transition-all d-flex flex-column h-100"
    >
      <navbar
        v-if="!is_onboarding_system_layout"
        :show_mobile_drawer="show_mobile_drawer"
        :hide_hamburger="should_hide_sidebar"
        @toggle-sidebar="toggle_sidebar"
        @open-onboarding="open_onboarding_modal"
        :class="[
          'sticky-top bg-white z-3 border-bottom config-top-navbar',
          show_navbar_overlap ? 'config-top-navbar-overlap' : ''
        ]"
      />

      <div class="main-content border-card rounded-0 overflow-auto scroll-container" :class="{ 'onboarding-main-content': is_onboarding_system_layout }">
        <div v-if="is_onboarding_system_layout" class="onboarding-content-frame">
          <div class="onboarding-content-primary">
            <navbar
              :show_mobile_drawer="show_mobile_drawer"
              :hide_hamburger="should_hide_sidebar"
              :show_mobile_ai_drawer="show_mobile_ai_drawer"
              @toggle-sidebar="toggle_sidebar"
              @toggle-ai-sidebar="toggle_ai_sidebar"
              @open-onboarding="open_onboarding_modal"
              class="sticky-top bg-white z-3 border-bottom config-top-navbar"
            />
            <router-view v-slot="{ Component }">
              <keep-alive max="12">
                <component :is="Component" />
              </keep-alive>
            </router-view>
          </div>
          <OnboardingAiPanel
            :mobile_open="show_mobile_ai_drawer"
            :summary_label="onboarding_ai_panel_content.summary_label"
            :summary_intro="onboarding_ai_panel_content.summary_intro"
            :briefing_body="onboarding_ai_panel_content.briefing_body"
            :briefing_meta="onboarding_ai_panel_content.briefing_meta"
            :suggested_questions="onboarding_ai_panel_content.suggested_questions"
            :recent_evidence="onboarding_ai_panel_content.recent_evidence"
            :input_placeholder="onboarding_ai_panel_content.input_placeholder"
            @close-mobile-panel="close_mobile_ai_sidebar"
            @question-selected="handle_onboarding_ai_question_selected"
            @submit-question="handle_onboarding_ai_question_submit"
          />
        </div>

        <router-view v-else class="mt-1"></router-view>
      </div>
    </div>
  </div>

  <div
    v-if="onboarding_modal_visible"
    class="onboarding-create-modal-backdrop"
    @click.self="close_onboarding_modal"
  >
    <section class="onboarding-create-modal">
      <header class="onboarding-create-modal-header">
        <div>
          <h2 class="onboarding-create-modal-title">New onboarding</h2>
          <p class="onboarding-create-modal-copy">
            Select a journey and template; OnboardOS sets the required documents, verifications, approvals and activation conditions.
          </p>
        </div>
        <button type="button" class="onboarding-create-modal-close" aria-label="Close new onboarding" @click="close_onboarding_modal">
          <i class="bi bi-x-lg"></i>
        </button>
      </header>

      <div class="onboarding-create-modal-body">
        <div v-if="onboarding_error" class="alert alert-danger">
          {{ onboarding_error }}
        </div>

        <div v-if="is_loading_onboarding_options" class="text-center text-muted py-5">
          Loading onboarding configuration...
        </div>

        <form v-else @submit.prevent="submit_new_onboarding">
          <div class="onboarding-create-field">
            <label class="onboarding-create-label">Candidate / company name</label>
            <select
              v-model="onboarding_form.entity_profile_id"
              class="form-select onboarding-create-control"
              :disabled="is_loading_onboarding_companies"
              @change="on_onboarding_company_change"
            >
              <option value="" disabled>
                {{ is_loading_onboarding_companies ? 'Loading candidate / company names...' : 'Select candidate / company name' }}
              </option>
              <option
                v-for="company in onboarding_companies"
                :key="company.id"
                :value="company.id"
              >
                {{ onboarding_project_display_name(company) }}
              </option>
              <option v-if="!is_loading_onboarding_companies && onboarding_companies.length === 0" value="" disabled>
                No backend projects found
              </option>
            </select>
          </div>

          <div class="row g-3 onboarding-create-field">
            <div class="col-12 col-md-6">
              <label class="onboarding-create-label">Journey</label>
              <select
                v-model="onboarding_form.entity_type_id"
                class="form-select onboarding-create-control"
                :disabled="!onboarding_form.entity_profile_id || !available_onboarding_entity_types.length"
                @change="on_onboarding_journey_change()"
              >
                <option value="" disabled>
                  {{ !onboarding_form.entity_profile_id ? 'Select candidate / company name first' : 'Select journey' }}
                </option>
                <option
                  v-for="entity_type in available_onboarding_entity_types"
                  :key="entity_type.id"
                  :value="entity_type.id"
                >
                  {{ entity_type.name }}
                </option>
                <option
                  v-if="onboarding_form.entity_profile_id && !available_onboarding_entity_types.length"
                  value=""
                  disabled
                >
                  No backend journeys found
                </option>
              </select>
            </div>

            <div class="col-12 col-md-6">
              <label class="onboarding-create-label">Template</label>
              <div
                ref="onboardingTemplatePicker"
                class="position-relative onboarding-create-template-picker"
              >
                <button
                  type="button"
                  class="form-select onboarding-create-control text-start"
                  :disabled="!onboarding_forms.length"
                  @click="toggle_onboarding_template_dropdown"
                >
                  {{ onboarding_template_label }}
                </button>

                <div
                  v-if="show_onboarding_template_dropdown"
                  class="template-multiselect-menu rounded-2 shadow-sm mt-1"
                >
                  <div class="onboarding-create-template-search p-2">
                    <input
                      v-model="onboarding_template_search"
                      type="search"
                      class="form-control onboarding-create-control onboarding-create-search-control"
                      placeholder="Search template"
                      @click.stop
                    >
                  </div>

                  <label
                    v-for="form in filtered_onboarding_forms"
                    :key="form.id"
                    class="dropdown-item template-multiselect-item d-flex align-items-center gap-2 py-2 mb-0"
                  >
                    <input
                      type="checkbox"
                      class="form-check-input mt-0"
                      :checked="is_onboarding_template_selected(form.id)"
                      @change="toggle_onboarding_template(form)"
                    >
                    <span class="text-truncate">{{ form.name }}</span>
                  </label>

                  <div
                    v-if="!filtered_onboarding_forms.length"
                    class="dropdown-item text-muted template-multiselect-item py-2"
                  >
                    {{ onboarding_form.entity_type_id ? 'No backend templates found' : 'Select journey first' }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row g-3 onboarding-create-field">
            <div class="col-12 col-md-6">
              <label class="onboarding-create-label">Owner</label>
              <div
                ref="onboardingOwnerPicker"
                class="position-relative onboarding-create-owner-picker"
              >
                <button
                  ref="onboardingOwnerButton"
                  type="button"
                  class="form-select onboarding-create-control text-start"
                  :disabled="is_loading_onboarding_roles"
                  @click="toggle_onboarding_owner_dropdown"
                >
                  {{ onboarding_role_label }}
                </button>

                <div
                  v-if="show_onboarding_owner_dropdown"
                  class="template-multiselect-menu onboarding-create-floating-menu rounded-2 shadow-sm mt-1"
                  :style="role_dropdown_style"
                >
                  <div class="onboarding-create-owner-search p-2">
                    <input
                      v-model="onboarding_role_search"
                      type="search"
                      class="form-control onboarding-create-control onboarding-create-search-control"
                      placeholder="Search role"
                      @click.stop
                    >
                  </div>

                  <label
                    v-for="role in filtered_onboarding_roles"
                    :key="role.id"
                    class="dropdown-item template-multiselect-item d-flex align-items-center gap-2 py-2 mb-0"
                  >
                    <input
                      type="checkbox"
                      class="form-check-input mt-0"
                      :checked="is_onboarding_role_selected(role.id)"
                      @change="toggle_onboarding_role(role)"
                    >
                    <span class="text-truncate">{{ onboarding_role_display_name(role) }}</span>
                  </label>

                  <div
                    v-if="!filtered_onboarding_roles.length"
                    class="dropdown-item text-muted template-multiselect-item py-2"
                  >
                    No roles found
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <label class="onboarding-create-label">Activate by</label>
              <input
                v-model="onboarding_form.activate_by"
                type="date"
                class="form-control onboarding-create-control"
              >
            </div>
          </div>

          <div class="onboarding-create-field">
            <label class="onboarding-create-label">{{ onboarding_entity_name_label }}</label>
            <input
              v-model="onboarding_form.entity_name"
              type="text"
              class="form-control onboarding-create-control"
              :placeholder="onboarding_entity_name_placeholder"
            >
          </div>

          <div class="onboarding-create-field">
            <div class="form-check form-switch onboarding-create-login-switch">
              <input
                id="onboarding_allow_login"
                v-model="onboarding_form.allow_login"
                type="checkbox"
                class="form-check-input"
              >
              <label for="onboarding_allow_login" class="form-check-label">
                Allow login - create user account with email invitation
              </label>
            </div>
            <p v-if="onboarding_form.allow_login" class="onboarding-create-muted-note mb-2">
              When enabled, this person can log in and complete their onboarding forms.
            </p>
            <template v-if="onboarding_form.allow_login">
              <label class="onboarding-create-label">Email</label>
              <input
                v-model="onboarding_form.email"
                type="email"
                class="form-control onboarding-create-control"
                placeholder="Enter email address"
              >
            </template>
          </div>

          <div class="onboarding-create-field mb-2">
            <div class="onboarding-create-label mb-2">Required at submit</div>
            <div class="onboarding-create-required-list">
              <span
                v-for="section in onboarding_required_sections"
                :key="section.id || section.label"
                class="onboarding-create-required-pill"
              >
                <i class="bi bi-check2" aria-hidden="true"></i>
                {{ section.label }}
              </span>
              <span v-if="is_loading_required_sections" class="onboarding-create-muted-note">Loading sections...</span>
              <span v-else-if="onboarding_required_sections.length === 0" class="onboarding-create-muted-note">No main sections returned for this template.</span>
            </div>
          </div>

          <p class="onboarding-create-muted-note mb-0">
            Selected items must be attached before the onboarding can advance past Documents.
          </p>
        </form>
      </div>

      <footer class="onboarding-create-modal-footer">
        <button type="button" class="onboarding-create-cancel-button" @click="close_onboarding_modal">
          Cancel
        </button>
        <button
          type="button"
          class="onboarding-create-submit-button"
          :disabled="is_creating_onboarding || is_loading_onboarding_options || is_loading_onboarding_companies || is_loading_onboarding_roles"
          @click="submit_new_onboarding"
        >
          <span v-if="is_creating_onboarding" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
          <i v-else class="bi bi-plus-lg"></i>
          <span>{{ is_creating_onboarding ? 'Creating...' : 'Create onboarding' }}</span>
        </button>
      </footer>
    </section>
  </div>

  <div
    v-if="entity_onboarding_modal_visible"
    class="onboarding-create-modal-backdrop"
    @click.self="close_entity_onboarding_modal"
  >
    <section class="onboarding-create-modal">
      <header class="onboarding-create-modal-header">
        <div>
          <h2 class="onboarding-create-modal-title">New onboarding</h2>
          <p class="onboarding-create-modal-copy">
            Choose what you want to onboard as. The assigned intake sheet will open for your login.
          </p>
        </div>
        <button
          type="button"
          class="onboarding-create-modal-close"
          aria-label="Close new onboarding"
          @click="close_entity_onboarding_modal"
        >
          <i class="bi bi-x-lg"></i>
        </button>
      </header>

      <div class="onboarding-create-modal-body">
        <div v-if="entity_onboarding_error" class="alert alert-warning">
          {{ entity_onboarding_error }}
        </div>

        <div v-if="is_loading_entity_onboarding_options" class="text-center text-muted py-5">
          Loading onboarding types...
        </div>

        <form v-else @submit.prevent="submit_entity_onboarding_case">
          <div class="onboarding-create-field">
            <label class="onboarding-create-label">Onboarding type</label>
            <select
              v-model="entity_onboarding_form.entity_type_id"
              class="form-select onboarding-create-control"
              :disabled="!entity_onboarding_types.length"
              @change="handle_entity_onboarding_type_change"
            >
              <option value="" disabled>Select onboarding type</option>
              <option
                v-for="entity_type in entity_onboarding_types"
                :key="entity_onboarding_type_id(entity_type)"
                :value="String(entity_onboarding_type_id(entity_type))"
              >
                {{ entity_onboarding_type_label(entity_type) }}
              </option>
            </select>
          </div>

          <div class="onboarding-create-field mb-2">
            <div class="onboarding-create-label mb-2">Assigned intake sheets</div>
            <div class="onboarding-create-required-list">
              <span v-if="is_loading_entity_onboarding_forms" class="onboarding-create-muted-note">
                Loading intake sheets...
              </span>
              <template v-else>
                <span
                  v-for="form in entity_onboarding_forms"
                  :key="form.id"
                  class="onboarding-create-required-pill"
                >
                  {{ form.name }}
                </span>
              </template>
              <span
                v-if="!is_loading_entity_onboarding_forms && entity_onboarding_forms.length === 0"
                class="onboarding-create-muted-note"
              >
                No configured intake sheets found for this onboarding type yet.
              </span>
            </div>
          </div>

          <p class="onboarding-create-muted-note mb-0">
            If this onboarding already exists, you will continue the existing intake instead of creating a duplicate.
          </p>
        </form>
      </div>

      <footer class="onboarding-create-modal-footer">
        <button type="button" class="onboarding-create-cancel-button" @click="close_entity_onboarding_modal">
          Cancel
        </button>
        <button
          type="button"
          class="onboarding-create-submit-button"
          :disabled="is_creating_entity_onboarding || is_loading_entity_onboarding_options || !entity_onboarding_form.entity_type_id"
          @click="submit_entity_onboarding_case"
        >
          <span v-if="is_creating_entity_onboarding" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
          <i v-else class="bi bi-plus-lg"></i>
          <span>{{ entity_onboarding_submit_label() }}</span>
        </button>
      </footer>
    </section>
  </div>
</div>


